@if (!formForgotPass) {
  <auth-layout titulo="Acesse sua conta" subtitulo="Entre para acompanhar os pacientes e as medições.">
    <login-form (forgotPassword)="forgotPassword()"></login-form>
  </auth-layout>
} @else {
  <auth-layout titulo="Esqueceu a senha?" subtitulo="Não se preocupe! Enviaremos um link de redefinição para o seu e-mail.">
    <forgot-form (forgotPassword)="forgotPassword()"></forgot-form>
  </auth-layout>
}
